import { useState } from "react";

interface SecretInputProps {
  value: string;
  onChange: (v: string) => void;
  isSet: boolean;
  placeholder?: string;
  id?: string;
  name?: string;
  disabled?: boolean;
  ariaLabel?: string;
}

/**
 * Password-style input with a reveal-eye toggle.
 *
 * The previously-stored secret value is never returned by the API, so the
 * component only ever reveals the value the user is currently typing.
 */
export function SecretInput({
  value,
  onChange,
  isSet,
  placeholder,
  id,
  name,
  disabled,
  ariaLabel,
}: SecretInputProps) {
  const [revealed, setRevealed] = useState(false);
  const ph = placeholder ?? (isSet ? "********" : "");

  return (
    <div className="ac-secret-input">
      <input
        id={id}
        name={name}
        type={revealed ? "text" : "password"}
        className="ac-input ac-secret-input__field"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={ph}
        disabled={disabled}
        aria-label={ariaLabel}
        autoComplete="new-password"
      />
      <button
        type="button"
        className="ac-secret-input__toggle"
        onClick={() => setRevealed((v) => !v)}
        aria-pressed={revealed}
        aria-label={revealed ? "Hide value" : "Reveal value"}
        title={revealed ? "Hide" : "Reveal"}
        tabIndex={-1}
      >
        {revealed ? "🙈" : "👁"}
      </button>
    </div>
  );
}
